import config from "../config"
import data from "../data"

let stripeHandler = null

// called once the script is loaded
const configure = () => {
  stripeHandler = window.StripeCheckout.configure({
    key:config.stripe.key,
    image:`https://storage.googleapis.com/appentura/static/logo_for_stripe.png`
  })
}

// inits stripe
const init = () => {
  if(stripeHandler == null) {
    if(!window.StripeCheckout) {
      const script = document.createElement('script')
      script.onload = configure
      script.src = 'https://checkout.stripe.com/checkout.js'
      document.head.appendChild(script)
    }
    else {
      configure()
    }
  }
}

const pay = (onToken, onClosed) => {
  let adventure = data.Cart.getAdventure()
  let amount = adventure.totalAdventureCost

  stripeHandler.open({
    token:(token) => { onToken(token.id) },
    closed:onClosed,
    name: 'Appentura',
    description: 'Dein Appentura-Erlebnis',
    amount: amount * 100,
    currency: config.currency,
    email: adventure.ClientEmail,
    //closed: function () { onPaymentClosed(); },
    allowRememberMe: false,
    panelLabel: `{{amount}} bezahlen`
  })
}

export default {
  init,
  pay
}